import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=template&id=b8806326&scoped=true"
import script from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=script&lang=js"
export * from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=style&index=0&id=b8806326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8806326",
  null
  
)

export default component.exports